<!--
  Lidの参加有無
-->
<template>
  <v-main class="pa-0">
    <div class="pa-4 d-flex align-center">
      <p class="pagetitle mb-0">参加中のLid</p>
      <v-spacer></v-spacer>
      <v-icon v-if="device==='pc'" x-large @click="$emit('closeProfile')">mdi-close</v-icon>
    </div>
    <v-list id="activitylog" class="overflow-x-hidden overflow-y-auto" style="height:75vh;">
      <v-list-item v-for="lid in lidque" :key="lid.id">
        <v-card
          class="d-flex align-center overflow-hidden rounded-sm"
          elevation="2"
          width="90%"
        >
          <v-img
            class="ml-0"
            max-height="65px"
            max-width="10"
            src="../../../assets/png/rectangle3.png"
          ></v-img>
          <span class="ml-4">> {{ lid.title }}</span>
          <span v-if="false">：{{ lid.ideaDesc }}</span>
        </v-card>
      </v-list-item>
    </v-list>
  </v-main>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
export default {
  data() {
    return {
      db: firebase.firestore(),
      uid: firebase.auth().currentUser.uid,
      lidque: [],
    };
  },
  props: ["profuid", "device"],
  created() {
    this.getLid();
  },
  watch: {
    profuid: function (profuid) {
      this.getLid();
    },
  },
  methods: {
    getLid() {
      const basecollection = this.db
        .collection("0")
        .where("isActive", "==", true);
      let liduserref;
      let lidid;
      let self = this;
      basecollection.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // Lidごと
          if (!doc.data().config) {
            //Configでない場合、Liduserコレクションに名前があるかを確認
            lidid = doc.id;
            liduserref = this.db
              .collection("0")
              .doc(lidid)
              .collection("liduser")
              .doc(this.profuid);
            liduserref
              .get()
              .then((doc2) => {
                if (doc2.exists&&doc2.data()?.isActive) {
                  self.lidque.push(doc.data());
                }
              })
              .catch((error) => {
                console.error("プロフィールのLiduser確認でのデータ取得にてエラーが発生しました。", error);
              });
          }
        });
      });
    },
  },
};
</script>
  
<style scoped>
.pagetitle {
  font-size: 25px;
  color: #707070;
}
* {
  font-family: mplus-2c-medium;
}
</style>